import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Clear } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";

import { Button, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";

const SmartSearch = ({
  options,
  onActionClick,
  isSearchMode,
  onCancelClick,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [searchwith, setSearchwith] = useState(null);

  const searchText = (e) => {
    setSearchValue(e.target.value);
  };

  const searchonclick = (type) => {
    if (type === "date" && !searchValue.includes("/")) {
      setSearchValue("");
    }
    setSearchwith(type);
  };
  const onClickClose = () => {
    setSearchValue("");
    setSearchwith(null);
    onCancelClick();
  };
  return (
    <>
      <div className="searchContainer">
        <TextField
          sx={{ width: "60%" }}
          disabled={isSearchMode}
          InputProps={{
            endAdornment:
              !!searchwith &&
              searchwith?.length > 0 &&
              (isSearchMode ? (
                <Button
                  size="small"
                  sx={{ mr: 0 }}
                  onClick={() => onClickClose()}
                >
                  <Clear color="error" />
                </Button>
              ) : (
                <Button size="small" sx={{ mr: -1.5, px: 0 }}>
                  <SearchOutlinedIcon
                    onClick={() => {
                      onActionClick({
                        searchWith: searchwith,
                        searchValue: searchValue,
                      });
                    }}
                  />
                </Button>
              )),
            startAdornment: !isSearchMode &&
              !!searchwith &&
              searchwith?.length > 0 && (
                <Box sx={{ mr: 1 }}>
                  <Box
                    sx={{
                      backgroundColor: "#dfe3e9",
                      py: 1,
                      px: 0.3,
                      ml: -1.5,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      fontSize={10}
                      sx={{ whiteSpace: "nowrap", p: 0.2 }}
                    >
                      {searchwith}
                    </Typography>

                    <ClearIcon
                      sx={{ cursor: "pointer" }}
                      fontSize="small"
                      onClick={() => {
                        setSearchValue("");
                        setSearchwith(null);
                      }}
                    />
                  </Box>
                </Box>
              ),
          }}
          variant="outlined"
          type="text"
          size="small"
          placeholder={searchwith === "Date" ? "DD/MM/YYYY" : "Search"}
          onChange={searchText}
          value={searchValue}
        />

        {searchwith === null && searchValue?.length > 0 && (
          <div className="searchContainerOption">
            {options?.map((item) => {
              return (
                <div onClick={() => searchonclick(item?.id)} key={item?.id}>
                  <b>{searchValue}</b> {item?.label}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default SmartSearch;
